import { Form, Input, Select, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useGetSystemBank, useGetUserBank } from '../../../../../api/bank'
import Arrowdown from '../../../../../common/images/png/ArrowDown.png'
import { ReactComponent as CheckSelectIcon } from '../../../../../common/images/svg/CheckSelect.svg'
import { ReactComponent as PlusGradientIcon } from '../../../../../common/images/svg/PlusGradient.svg'
import { ReactComponent as ArrowIcon } from '../../../../../common/images/svg/SuffixSelectIcon.svg'
import { ReactComponent as ClearIcon } from '../../../../../common/images/svg/XCircle.svg'
import { CustomButton } from '../../../../../components/button/buttonCustom'
import { ButtonOutlinedCustom } from '../../../../../components/button/buttonOulined'
import {
  accountNumberRules,
  branchNumberRules,
  clearFieldErrorMessageOnChange,
  onlyLatinCharsDigitsRule,
} from '../../../../../utils/form.constants'
import useResponsive from '../../../../../utils/hooks/useResponsive'
import { BankBeneficiary } from '../../../type'
import FormBankAddNew from './form-bank-add-new'

const { Option, OptGroup } = Select

interface IFormBankProps {
  onSubmitBank: (values: BankBeneficiary) => void
  onBack: () => void
  onSkip: () => void
  stepNewBeneficiary: number | null
  bankSelected: any
  valueFormBank: BankBeneficiary | undefined
  setBankSelected: React.Dispatch<any>
  metadataCountries: { value: string; label: string }[]
  metadataCurrency: { value: string; label: string }[]
}

const start = 0
const end = 10
const requiredFields = [
  'bankId',
  'accountNumber',
  'currencyCode',
  'branchNumber',
]

const requiredFieldsAddNew = [
  'accountNumber',
  'currencyCode',
  'branchNumber',
  'bankName',
  'bankSwift',
  'bankAddress',
  'bankCountry',
]

const FormBank = ({
  onSubmitBank,
  onBack,
  onSkip,
  stepNewBeneficiary,
  bankSelected,
  setBankSelected,
  metadataCountries,
  metadataCurrency,
  valueFormBank,
}: IFormBankProps) => {
  const { isTablet } = useResponsive()
  const [form] = Form.useForm<BankBeneficiary>()
  const [addNewBank, setAddNewBank] = useState(false)
  const [params, setParams] = useState({ start, end })
  const [paramSystem, setParamSystem] = useState({ start, end })
  const [searchBank, setSearchBank] = useState()
  const [searchCurrency, setSearchCurrency] = useState<string>('')
  const [isAllFieldsFilled, setIsAllFieldsFilled] = useState(true)
  const [valueSkipForm, setValueSkipForm] = useState<any>()

  // const bankId = Form.useWatch('bankId', form)
  // const accountNumber = Form.useWatch('accountNumber', form)
  // const currencyCode = Form.useWatch('currencyCode', form)
  // const abaRoutingNumber = Form.useWatch('abaRoutingNumber', form)
  // const bankStateBranchNumber = Form.useWatch('bankStateBranchNumber', form)
  // const branchNumber = Form.useWatch('branchNumber', form)

  // const bankName = Form.useWatch('bankName', form)
  // const bankSwift = Form.useWatch('bankSwift', form)
  // const bankAddress = Form.useWatch('bankAddress', form)
  // const bankCountry = Form.useWatch('bankCountry', form)

  const { data: metadataUserBank = { data: [] } } = useGetUserBank({
    start: params.start,
    end: params.end,
    name: searchBank,
  })

  const { data: metadataSystemBank = { data: [] } } = useGetSystemBank({
    start: paramSystem.start,
    end: paramSystem.end,
    name: searchBank,
  })

  const handleChangeCurrency = (value: string) => {
    setSearchCurrency(value)
  }

  // useEffect(() => {
  //   const fields = addNewBank ? requiredFieldsAddNew : requiredFields
  //   const values = form.getFieldsValue(fields as any)
  //   const allFilled = fields.every((field) => !!values[field])
  //   setIsAllFieldsFilled(allFilled)
  // }, [
  //   addNewBank,
  //   bankId,
  //   accountNumber,
  //   currencyCode,
  //   abaRoutingNumber,
  //   bankStateBranchNumber,
  //   branchNumber,
  //   bankName,
  //   bankSwift,
  //   bankAddress,
  //   bankCountry,
  // ])

  useEffect(() => {
    if (addNewBank) return
    form?.setFieldValue('bankId', bankSelected?.id)
  }, [addNewBank])

  useEffect(() => {
    if (!valueFormBank && !valueSkipForm) return
    form.setFieldsValue({
      bankId: valueSkipForm?.bankId || valueFormBank?.bankId,
      accountNumber:
        valueSkipForm?.accountNumber || valueFormBank?.accountNumber,
      currencyCode: valueSkipForm?.currencyCode || valueFormBank?.currencyCode,
      abaRoutingNumber:
        valueSkipForm?.abaRoutingNumber && valueSkipForm?.abaRoutingNumber !== ''
          ? valueSkipForm?.abaRoutingNumber
          : valueFormBank?.abaRoutingNumber && valueFormBank?.abaRoutingNumber !== ''
            ? valueFormBank?.abaRoutingNumber
            : undefined,
      bankStateBranchNumber:
        valueSkipForm?.bankStateBranchNumber && valueSkipForm?.bankStateBranchNumber !== ''
          ? valueSkipForm?.bankStateBranchNumber
          : valueFormBank?.bankStateBranchNumber && valueFormBank?.bankStateBranchNumber !== ''
            ? valueFormBank?.bankStateBranchNumber
            : undefined,
      branchNumber: valueSkipForm?.branchNumber || valueFormBank?.branchNumber,
      bankName: valueSkipForm?.bankName || valueFormBank?.bankName,
      bankSwift: valueSkipForm?.bankSwift || valueFormBank?.bankSwift,
      bankAddress: valueSkipForm?.bankAddress || valueFormBank?.bankAddress,
      bankCountry: valueSkipForm?.bankCountry || valueFormBank?.bankCountry,
    })
  }, [valueFormBank, valueSkipForm, stepNewBeneficiary])

  return (
    <Form
      style={{ display: stepNewBeneficiary === 3 ? 'block' : 'none' }}
      form={form}
      onFinish={(value) => {
        onSubmitBank(value)
        setValueSkipForm(null)
        form.resetFields()
      }}
      onValuesChange={(_changeValue, _values) => {
        clearFieldErrorMessageOnChange(form)
        setValueSkipForm(_values)
      }}>
      <div className='form-content'>
        <div className='bank-detail'>
          <div className='bank-detail-header'>
            <Typography.Text
              style={{ lineHeight: isTablet ? '24px' : '32px' }}
              className='title-bank'>
              Bank Details
            </Typography.Text>
            {addNewBank ? (
              <ButtonOutlinedCustom
                text={'Cancel'}
                size={isTablet ? 'xsmall' : 'small'}
                width={79}
                onClick={() => setAddNewBank(false)}
              />
            ) : null}
          </div>
          {addNewBank ? (
            <FormBankAddNew metadataCountries={metadataCountries} />
          ) : (
            <div
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                gap: 12,
              }}>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'row',
                  gap: 16,
                }}>
                <Form.Item
                  label='Bank'
                  name='bankId'
                  validateTrigger='onBlur'
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}
                  className='select-bank-detail'>
                  <Select
                    allowClear
                    clearIcon={<ClearIcon style={{ height: 12, width: 12 }} />}
                    suffixIcon={bankSelected ? null : <ArrowIcon />}
                    showSearch
                    className='beneficiary-bank-account'
                    placeholder='Choose a bank'
                    popupClassName='custom-select-bank'
                    onSearch={(value: any) => {
                      setSearchBank(value)
                      setParams({ start: 0, end: 10 })
                    }}
                    onChange={(id) => {
                      const selected = [
                        ...metadataSystemBank.data,
                        ...metadataUserBank.data,
                      ].find((item: any) => item.id === id)
                      setBankSelected(selected)
                    }}
                    filterOption={() => true}>
                    <OptGroup label='User Bank'>
                      {Array.isArray(metadataUserBank.data) &&
                        metadataUserBank.data.map((item: any) => (
                          <Option key={item.id} value={item.id}>
                            <span
                              className='ant-select-custom-value'
                              style={{ whiteSpace: 'nowrap' }}>
                              {item.name}
                            </span>
                            {bankSelected?.id === item.id && (
                              <CheckSelectIcon />
                            )}
                          </Option>
                        ))}
                      {metadataUserBank.data.length === params.end && (
                        <Option key='load-more' disabled>
                          <span
                            style={{
                              fontSize: isTablet ? 12 : 14,
                              color: 'rgba(29, 171, 241, 1)',
                              fontWeight: 500,
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              e.stopPropagation()
                              setParams((prev) => ({
                                ...prev,
                                end: prev.end + 10,
                              }))
                            }}>
                            Load more <img src={Arrowdown} />
                          </span>
                        </Option>
                      )}
                    </OptGroup>
                    <div className='hr-bank-selected' />
                    <OptGroup label='System Banks'>
                      {Array.isArray(metadataSystemBank.data) &&
                        metadataSystemBank.data.map((item: any) => (
                          <Option key={item.id} value={item.id}>
                            <span
                              className='ant-select-custom-value'
                              style={{ whiteSpace: 'nowrap' }}>
                              {item.name}
                            </span>
                            {bankSelected?.id === item.id && (
                              <CheckSelectIcon />
                            )}
                          </Option>
                        ))}
                      {metadataSystemBank.data.length === paramSystem.end && (
                        <Option key='load-more' disabled>
                          <span
                            style={{
                              fontSize: isTablet ? 12 : 14,
                              color: 'rgba(29, 171, 241, 1)',
                              fontWeight: 500,
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              e.stopPropagation()
                              setParamSystem((prev) => ({
                                ...prev,
                                end: prev.end + 10,
                              }))
                            }}>
                            Load more <img src={Arrowdown} />
                          </span>
                        </Option>
                      )}
                    </OptGroup>
                  </Select>
                </Form.Item>
                <div
                  className='button-add-new-bank'
                  onClick={() => setAddNewBank(true)}>
                  <PlusGradientIcon />
                </div>
              </div>
              {bankSelected ? (
                <>
                  <Typography.Text
                    style={{
                      color: '#ffffff',
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}>{`Name: ${bankSelected?.name || ''}`}</Typography.Text>
                  <Typography.Text
                    style={{
                      color: '#ffffff',
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}>{`Swift: ${bankSelected?.swift || ''}`}</Typography.Text>
                  <Typography.Text
                    style={{
                      color: '#ffffff',
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}>{`Address: ${bankSelected?.legalAddress || ''
                      }`}</Typography.Text>
                </>
              ) : null}
            </div>
          )}
        </div>
        <div className='account-detail'>
          <Typography.Text className='title'>Account Details</Typography.Text>
          <Form.Item
            label='Account No or IBAN'
            name='accountNumber'
            validateTrigger='onBlur'
            rules={accountNumberRules}>
            <Input placeholder='Enter account number or IBAN' />
          </Form.Item>
          <Form.Item
            label='Currency'
            name='currencyCode'
            validateTrigger='onBlur'
            rules={[{ required: true, message: 'This field is required' }]}>
            <Select
              placeholder='Select the account currency'
              suffixIcon={<ArrowIcon />}
              onChange={handleChangeCurrency}
              optionLabelProp='label'>
              {metadataCurrency.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      gap: 2,
                    }}>
                    <span
                      className='ant-select-custom-value '
                      style={{ whiteSpace: 'nowrap' }}>
                      {item.label}
                    </span>
                    {searchCurrency === item.value && (
                      <CheckSelectIcon style={{ flexShrink: 0 }} />
                    )}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label='ABA Routing Number'
            name='abaRoutingNumber'
            validateTrigger='onBlur'
            rules={[
              {
                max: 25,
                message: 'Maximum 25 characters',
                validateTrigger: 'onBlur',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve()
                  const trimmed = value.trim()
                  if (trimmed.length < 4) {
                    return Promise.reject(new Error('Minimum 4 characters'))
                  }

                  return Promise.resolve()
                },
              },
              onlyLatinCharsDigitsRule,
            ]}>
            <Input
              placeholder='Enter the ABA routing number'
              onKeyDown={(e) => {
                const target = e.currentTarget as HTMLInputElement
                if (e.key === ' ' && target.selectionStart === 0) {
                  e.preventDefault()
                }
              }}
            />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
          <Form.Item
            label='Bank State Branch Number'
            name='bankStateBranchNumber'
            validateTrigger='onBlur'
            rules={[
              {
                max: 25,
                message: 'Maximum 25 characters',
                validateTrigger: 'onBlur',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve()
                  const trimmed = value.trim()
                  if (trimmed.length < 4) {
                    return Promise.reject(new Error('Minimum 4 characters'))
                  }

                  return Promise.resolve()
                },
              },
              onlyLatinCharsDigitsRule,
            ]}>
            <Input
              placeholder='Enter the BSB number'
              onKeyDown={(e) => {
                const target = e.currentTarget as HTMLInputElement
                if (e.key === ' ' && target.selectionStart === 0) {
                  e.preventDefault()
                }
              }}
            />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
          <Form.Item
            label='Branch Number'
            name='branchNumber'
            validateTrigger='onBlur'
            rules={branchNumberRules}>
            <Input placeholder='Enter the branch number' />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
        </div>
      </div>
      <div className='form-footer'>
        <Typography.Text
          style={{
            color: '#F28A28',
            fontSize: isTablet ? 10 : 12,
            fontWeight: 400,
            lineHeight: '16px',
          }}>
          {
            'You’ll be able to add more bank accounts after setting up the beneficiary.'
          }
        </Typography.Text>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          <ButtonOutlinedCustom
            text={'Back'}
            size={isTablet ? 'medium' : 'large'}
            width={136}
            onClick={() => {
              onBack()
              form.resetFields()
            }}
          />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <ButtonOutlinedCustom
              text={'Skip'}
              size={isTablet ? 'medium' : 'large'}
              width={126}
              onClick={() => {
                onSkip()
                form.resetFields()
              }}
            />
            <CustomButton
              type='submit'
              text={'Continue'}
              size={isTablet ? 'medium' : 'large'}
              disabled={!isAllFieldsFilled}
            />
          </div>
        </div>
      </div>
    </Form>
  )
}

export default FormBank
